/**
 * Where the app runs, from the hostname: 'local' (localhost / 127.0.0.1 / *.localhost), 'dev'
 * (dev-*), else 'prod'. Lets analytics filter dev / local tests out of the shared projects.
 */
export const APP_ENV = (() => {
    const host = (typeof window !== 'undefined' && window.location.hostname) || '';
    if (host === 'localhost' || host === '127.0.0.1' || host.endsWith('.localhost')) return 'local';
    if (host.startsWith('dev-')) return 'dev';
    return 'prod';
})();
